async function preloadMetaobjects() {
    if (window.OSHA_COURSES_CACHE) return window.OSHA_COURSES_CACHE;
    if (window.OSHA_COURSES_FETCHING) return window.OSHA_COURSES_FETCHING;

    const token = window.ShopifyStorefront?.accessToken;
    const shop = window.ShopifyStorefront?.shopDomain || window.Shopify.shop;

    if (!token) {
        console.warn('Storefront API Token missing from window.ShopifyStorefront.accessToken');
        return [];
    }
    window.OSHA_COURSES_FETCHING = (async () => {
        const query = `
        query getMetaobjectCourses($after: String) {
            metaobjects(type: "osha_course", first: 250, after: $after) {
            nodes {
                handle
                fields {
                key
                value
                reference {
                    ... on MediaImage {
                    image {
                        url
                    }
                    }
                }
                }
            }
            pageInfo {
                hasNextPage
                endCursor
            }
            }
        }
        `;

        let allCourses = [];
        let hasNextPage = true;
        let endCursor = null;

        try {
            while (hasNextPage) {
            const response = await fetch(`https://${shop}/api/2026-07/graphql.json`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': token
            },
            body: JSON.stringify({
                query,
                variables: { after: endCursor }
            })
            });

            const json = await response.json();
            const metaobjectData = json?.data?.metaobjects;

            if (!metaobjectData) break;

            const nodes = (metaobjectData.nodes || []).map((node) => {
            const fieldsMap = Object.fromEntries(node.fields.map((f) => [f.key, f]));
            const courseTitle = fieldsMap.course_name?.value || node.handle;
            const regulation = fieldsMap.governing_regulation_citation?.value || '';
            const industries = fieldsMap.primary_industries?.value || '';
            const metaobjectImgUrl = fieldsMap.image?.reference?.image?.url || fieldsMap.image?.value || '';

            return {
                handle: node.handle,
                title: courseTitle,
                regulatoryBody: fieldsMap.governing_regulaton_citation?.value || 'OSHA',
                price: fieldsMap.est_msrp?.value ? `$${fieldsMap.est_msrp?.value} USD` : '',
                priceDisplay: (fieldsMap.est_msrp?.value ? `Prices From $${fieldsMap.est_msrp?.value} Per Seat` : ''),
                duration: fieldsMap.suggested_duration?.value || '',
                imageUrl: metaobjectImgUrl,
                searchIndex: `${courseTitle} ${regulation} ${industries}`.toLowerCase()
            };
            });

            allCourses = allCourses.concat(nodes);
            hasNextPage = metaobjectData.pageInfo?.hasNextPage || false;
            endCursor = metaobjectData.pageInfo?.endCursor || null;
        }

        window.OSHA_COURSES_CACHE = allCourses;
        return allCourses;
        } catch (err) {
        console.error('Failed to load course metaobjects into cache:', err);
        return [];
        } finally {
        window.OSHA_COURSES_FETCHING = null;
        }
    })();
    return window.OSHA_COURSES_FETCHING;
}

function calculateRelevanceScore(title, searchTerm) {
    const titleLower = title.toLowerCase().trim();
    const termLower = searchTerm.toLowerCase().trim();
    const terms = termLower.split(/\s+/);

    // 1. Exact match gets highest score
    if (titleLower === termLower) return 1000;

    let score = 0;

    // 2. Starts with search term
    if (titleLower.startsWith(termLower)) score += 500;

    // 3. Exact phrase match anywhere in title
    if (titleLower.includes(termLower)) score += 300;

    // 4. Individual word matching (word boundary vs substring)
    terms.forEach((term) => {
        const wordBoundaryRegex = new RegExp(`\\b${term}\\b`, 'i');
        if (wordBoundaryRegex.test(titleLower)) {
        score += 50; // Whole word match
        } else if (titleLower.includes(term)) {
        score += 20; // Partial match
        }
    });

    return score;
}
document.addEventListener('DOMContentLoaded', async () => {
const urlParams = new URLSearchParams(window.location.search);
const searchTerm = (urlParams.get('q') || '').trim().replace().toLowerCase().replace(/"/g, '');

if (!searchTerm) return;
window.OSHA_COURSES_CACHE = window.OSHA_COURSES_CACHE || null;
window.OSHA_COURSES_FETCHING = window.OSHA_COURSES_FETCHING || null;
const metaobjects = await preloadMetaobjects();
const gridContainer = document.getElementById('metaobject-search-grid');
const matchedCourses = metaobjects.filter((course) => course.searchIndex.includes(searchTerm)).map((course) => ({...course,relevanceScore: this.calculateRelevanceScore(course.title, searchTerm)})).sort((a, b) => b.relevanceScore - a.relevanceScore);
const statusMessage = document.querySelector('.template-search__header p[role="status"]');
if (matchedCourses.length > 0) {
    if (statusMessage) {
        statusMessage.style.display = 'none';
    }
    // Inside your matchedCourses.map() function:
    gridContainer.innerHTML = matchedCourses.map(course => {
        const rating = getCourseRating(course.handle);
        const courseUrl = `/pages/courses/${course.handle}`;
        return `
            <div class="osha-course-card">
            <div>
                <div class="osha-course-card__badge">${course.regulatoryBody}</div>

                <h3 class="osha-course-card__title">
                <a href="${courseUrl}">
                    ${course.title}
                </a>
                </h3>

                <div class="osha-course-card__price">
                ${course.priceDisplay || `Prices From $${course.price || '0.00'} Per Seat`}
                </div>

                <div class="osha-course-card__rating">
                <span class="osha-course-card__rating-score">(${rating})</span>
                <span class="osha-course-card__rating-stars">★★★★★</span>
                </div>
            </div>

            <div class="osha-course-card__duration">
                <span>Course Duration:</span>
                <svg class="osha-course-card__duration-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10"></circle>
                <polyline points="12 6 12 12 16 14"></polyline>
                </svg>
                <span class="osha-course-card__duration-text">${course.duration}</span>
            </div>
            </div>
        `;
    }).join('');
}
else {
    if (statusMessage) {
        statusMessage.style.display = 'block';
    }
}
});

function getCourseRating(handle) {
  let hash = 0;
  for (let i = 0; i < handle.length; i++) {
    hash = handle.charCodeAt(i) + ((hash << 5) - hash);
  }
  // Normalize hash to a float between 0 and 1
  const normalized = Math.abs((Math.sin(hash) * 10000) % 1);
  // Scale between 4.2 and 4.8 rounded to 1 decimal place
  return (4.2 + normalized * 0.6).toFixed(1);
}